<template>
  <div class="v-subscriptions-table">
    <v-subscription-create-update-form v-if="this.isShowModal"
                                 :subscription-id="this.subscriptionId"
                                 :status-list="this.statusList"
                                 @close="closeModal" />
    <v-subscription-info-modal v-if="this.isShowInfoModal"
                               :subscription="this.subscription"
                               @close="closeInfoModal"/>
    <v-subscription-address-update-modal v-if="this.isShowDealerModal"
                                        :subscription-id="this.subscriptionId"
                                        :subscription-address="this.subscriptionAddress"
                                        @close="closeDealerModal" />

    <table class="table">
      <thead>
        <tr>
          <th v-if="role === 'dealer'" scope="col">SIM карта</th>
          <th scope="col">Подписчик</th>
          <th scope="col">Адрес</th>
          <th scope="col">Баланс</th>
          <th scope="col">Тариф</th>
          <th v-if="role === 'administrator' || role === 'employee'" scope="col">Дилер</th>
          <th scope="col">Статус</th>
          <th scope="col"></th>
          <th v-if="role === 'administrator'" scope="col"></th>
          <th v-if="role === 'administrator'" scope="col"></th>
          <th v-if="role === 'administrator'" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="subscription in this.subscriptionList" :key="subscription.id">

          <td v-if="role === 'dealer'">
            {{ subscription.sim_card.new_serial_number }}
          </td>

          <td>
            {{ subscription.subscriber.last_name }}
            {{ subscription.subscriber.first_name }}
            <span v-if="subscription.is_alerted" class="badge badge-danger mr-1">alert</span>
            <span v-if="!subscription.subscription_payment[0]" class="badge badge-danger mr-1">
              WP
            </span>
            <span v-if="subscription.is_provider_disabled" class="badge badge-danger">
              BLOCK
            </span>
          </td>

          <td>
            {{subscription.address}}
          </td>

          <td>
            {{ subscription.subscriber.balance }}
          </td>

          <td v-if="subscription.tariff">{{ subscription.tariff.name }}</td>
          <td v-else>Без тарифа</td>

          <td v-if="subscription.sim_card.dealer && role === 'administrator' ||
            subscription.sim_card.dealer && role === 'employee'">
            {{ subscription.sim_card.dealer.last_name }}
            {{ subscription.sim_card.dealer.first_name }}
          </td>
          <td v-else-if="role === 'administrator'">Без дилера</td>

          <td>
            <span v-if="subscription.is_active === true" class="badge badge-success">Активна</span>
            <span v-else-if="subscription.is_active === null" class="badge badge-warning">
              Приостановлена</span>
            <span v-else class="badge badge-danger">Неактивна</span>
          </td>

          <td @click="showInfoModal(subscription)"
              v-if="role === 'administrator' || role === 'employee'">
            <font-awesome-icon :icon="['fa', 'info-circle']"/>
          </td>

          <td v-if="role === 'administrator'">
            <v-popover offset="26">
              <font-awesome-icon :icon="['fa', 'history']"/>
              <template slot="popover">
                <div v-for="log in subscription.logs.events" :key="log.datetime" class="pt-2">
                  <div class="font-weight-bold">{{fixDateAndTine(log.datetime)}}</div>
                  <div v-if="log.type === 'create'">
                    <span>Создание - </span>
                    <span>{{log.user_name}}</span>
                  </div>
                  <div v-if="log.type === 'suspend_enabled'">
                    <span>Приостановка исх. платежей - </span>
                    <span>{{log.user_name}}</span><br>
                    <span>До: {{log.suspended_until}}</span><br>
                    <span>Описание: {{log.description}}</span><br>
                  </div>
                  <div v-if="log.type === 'suspend_disabled'">
                    <span>Приостановка исх. платежей откл. - </span>
                    <span>{{log.user_name}}</span>
                  </div>
                  <div v-if="log.type === 'tariff_changed'">
                    <span>Изменение тарифа - </span>
                    <span>{{log.user_name}}</span><br>
                    <span>Было: {{log.old_tariff}} | Стало: {{subscription.tariff.name}}</span>
                  </div>
                  <div v-if="log.type === 'provider_disabled'">
                    <span>Отключение у провайдера - </span>
                    <span>{{log.user_name}}</span><br>
                    <span>Комментарий: {{log.description}}</span>
                  </div>
                  <div v-if="log.type === 'provider_enabled'">
                    <span>Включение у провайдера - </span>
                    <span>{{log.user_name}}</span>
                  </div>
                  <div v-if="log.type === 'delete'">
                    <span>Удаление</span>
                    <span>Сотрудник: {{log.user_name}}</span>
                  </div>
                  <div v-if="log.type === 'activate'">
                    <span>Активация - </span>
                    <span v-if="log.user_name">{{log.user_name}}</span>
                    <span v-else>Автоматичнски</span>
                  </div>
                  <div v-if="log.type === 'deactivate'">
                    <span>Деактивация - </span>
                    <span v-if="log.user_name">{{log.user_name}}</span>
                    <span v-else>Автоматичнски</span>
                  </div>
                  <div v-if="log.type === 'paused'">
                    <span>Приостановка - </span>
                    <span v-if="log.user_name">{{log.user_name}}</span>
                    <span v-else>Автоматичнски</span>
                  </div>
                </div>
                <div class="text-center pt-3">
                  <a v-close-popover>Закрыть</a>
                </div>
              </template>
            </v-popover>
          </td>

          <td @click="showModal(subscription.id)" v-if="role === 'administrator'">
            <font-awesome-icon :icon="['fa', 'cogs']"/>
          </td>

          <td @click="showDealerModal(subscription.id, subscription.address)"
              v-if="role === 'dealer'">
            <font-awesome-icon :icon="['fa', 'cogs']"/>
          </td>

          <td  @click="deleteSubscription(subscription.id)" v-if="role === 'administrator'">
            <font-awesome-icon :icon="['fa', 'trash']"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VSubscriptionCreateUpdateForm from '../forms/v-subscription-create-update-form.vue';
import VSubscriptionInfoModal from '../forms/v-subscription-info-modal.vue';
import VSubscriptionAddressUpdateModal from '../forms/v-subscription-address-update-modal.vue';

export default {
  name: 'v-subscriptions-table',
  components: {
    VSubscriptionAddressUpdateModal,
    VSubscriptionInfoModal,
    VSubscriptionCreateUpdateForm,
  },
  props: ['subscriptionList', 'role', 'statusList'],
  data() {
    return {
      isShowModal: false,
      isShowInfoModal: false,
      isShowDealerModal: false,
      subscriptionId: '',
      subscriptionAddress: '',
      subscription: '',
    };
  },
  methods: {
    showModal(subscription) {
      this.subscriptionId = subscription;
      this.isShowModal = true;
    },
    closeModal() {
      this.isShowModal = false;
      this.$emit('update');
    },
    showInfoModal(subscription) {
      this.subscription = subscription;
      this.isShowInfoModal = true;
    },
    closeInfoModal() {
      this.isShowInfoModal = false;
    },
    showDealerModal(id, address) {
      this.subscriptionId = id;
      this.subscriptionAddress = address;
      this.isShowDealerModal = true;
    },
    closeDealerModal() {
      this.isShowDealerModal = false;
      this.$emit('update');
    },

    deleteSubscription(id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы действительно хотите удалить этоу подписку?',
        buttons: [
          {
            title: 'Удалить подписку',
            handler: () => {
              this.$store.dispatch('subscription/deleteSubscription', id)
                .then(() => {
                  this.$emit('update');
                  this.$modal.hide('dialog');
                });
            },
          },
          {
            title: 'Закрыть',
            default: true,
          },
        ],
      });
    },
  },
};
</script>
